import React, { useState } from 'react'
import { api } from 'src/services/api'
import offImage from './../../../assets/off.png'
import onImage from './../../../assets/on.png'
import { ToogleDiv } from './styles'

interface ToggleSwitchFavoriteProps {
  userId: string
  initialStatus: boolean
}

const ToggleActiveAccount: React.FC<ToggleSwitchFavoriteProps> = ({
  initialStatus,
  userId,
}) => {
  const [isOn, setIsOn] = useState(initialStatus)

  const handleToggle = async () => {
    const newStatus = !isOn

    const token = localStorage.getItem('@backoffice:token')

    const result = await api.post(
      '/toggle-wallet-account',
      {
        graphicAccountId: userId,
        isActive: newStatus,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )

    setIsOn(newStatus)
  }

  return (
    <ToogleDiv onClick={handleToggle} style={{ cursor: 'pointer' }}>
      <img
        src={isOn ? onImage : offImage}
        alt={isOn ? 'On' : 'Off'}
        style={{ width: '100px', height: '40px' }}
      />
    </ToogleDiv>
  )
}

export default ToggleActiveAccount
